import { loadStripe } from "@stripe/stripe-js";
import Cookies from "js-cookie";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { dynamicsService } from "../services/DynamicsService";
import { AvailableTimeSlot } from "../types/DynamicsService";
import Col100 from "./Col100";
import Processing from "./Processing";

type Props = {
  onComplete: ((opportunityId: string) => void);
  // client: Contact;
  clientId?: string | undefined;
  timeSlot?: AvailableTimeSlot | undefined;
  primaryContactId?: string | undefined;
  partner?: string | undefined;
};
export default function PayFirst(props: Props): JSX.Element {
  const { onComplete, clientId, timeSlot, primaryContactId } = props;

  // Accessors
  // const date = DateTime.fromISO(timeSlot?.date);
  const listPrice = parseInt(window.orderAssessmentConfig.listPrice);
  const listPricePaymentPlan = parseInt(window.orderAssessmentConfig.listPricePaymentPlan);
  // const stripePrice = window.orderAssessmentConfig.stripePrice;
  const stripePricePaymentPlan = window.orderAssessmentConfig.stripePricePaymentPlan

  // Local state
  const tomorrow = DateTime.fromObject({
    hour: 0,
    minute: 0,
    second: 0
  }).plus({
    days: 1
  });
  //const [payAsYouGo, setPayAsYouGo] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDiscountCode, setShowDiscountCode] = useState(false);
  const [paymentRequired, setPaymentRequired] = useState(false);
  const purchaseButtonText = window.orderAssessmentConfig.payButtonText ?? "Purchase Membership";
  const activateButtonText = "Activate Membership";

  const [partner, setPartner] = useState(Cookies.get("da_partner") ?? props.partner ?? '');
  const [inputs, setInputs] = useState({
    assessmentDate: tomorrow
      .plus({
        days: 2
      })
      .toISODate(),
    selectedTimeSlot: "",
    code: partner,
  });
  const [error, setError] = useState<string>();
  // const [price, setPrice] = useState<number>(listPrice);
  // const [pricePaymentPlan, setPricePaymentPlan] = useState<number>(listPricePaymentPlan);

  // Event Handlers
  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) {
    const { name, value } = e.target;
    // setIsDirty(true);
    setInputs(inputs => ({
      ...inputs,
      [name]: value
    }));
  }

  async function handleCode(e: React.FormEvent) {
    console.log("handleCode", e);
    e.preventDefault();
    setPartner(inputs.code);
    setShowDiscountCode(false);
  }

  async function handleSubmit(e: React.FormEvent) {
    const stripe = await loadStripe(
      window.orderAssessmentConfig.stripePublishableKey
    );
    console.log("handleSubmit", e);
    e.preventDefault();
    setSubmitting(true);
    if (stripe) {
      const baseUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      dynamicsService
        .createCheckoutSession(
          stripePricePaymentPlan,
          'subscription', //payAsYouGo ? 'subscription' : 'payment',
          baseUrl,
          partner,
        )
        .then(session => {
          // console.log("Primary Contact ID ", primaryContactId);
          //   console.log(session);
          //   console.log("client", clientId);
          if (session.complete) {
            onComplete(session.checkoutId);
          } else {
            stripe
              .redirectToCheckout({
                sessionId: session.sessionId
              })
              .then(result => {
                if (result.error) {
                  // If `redirectToCheckout` fails due to a browser or network
                  // error, display the localized error message to your customer
                  // using `result.error.message`.
                  console.error(result.error);
                  setError(result.error.message);
                }
              });
          }
        })
        .catch(reason => {
          setError("We are unable to collect payment for your assessment.");
          console.log(reason);
        });
      return;
    }
    console.error("stripe session invalid");
    setError("We are unable to process payment for your session.");
  }

  // Onload, check for discounted price
  useEffect(
    () => {
      setLoading(true);
      dynamicsService.getCodeDiscount(partner).then(response => {
        setPaymentRequired(response.isPaymentRequired);

        // setPrice(listPrice - response.discount);
        // const newPricePaymentPlan = listPricePaymentPlan - response.discount;
        // setPricePaymentPlan(newPricePaymentPlan);
        setLoading(false);
        // if (newPricePaymentPlan <= 0) {
        //   // Cannot select paymetn plan if your discount is more than the 1st payment
        //   setPayAsYouGo(false);
        // }
      }).catch((err) => {
        setError(err);
      });
    },
    [listPrice, listPricePaymentPlan, partner]
  );

  if (error) {
    return (
      <Col100>
        <strong>ERROR!</strong> {error}
        <button
          className="elementor-button elementor-button-align-stretch elementor-size-sm"
          onClick={() => {
            setSubmitting(false);
            setError(undefined);
          }}
        >
          <span>
            <span className="elementor-align-icon-right elementor-button-icon">
              <i aria-hidden="true" className="fas fa-angle-right" />{" "}
            </span>
            <span className="elementor-button-text">Try Again</span>
          </span>
        </button>
      </Col100>
    );
  }
  if (submitting || loading) {
    return (
      <Col100>
        <Processing />
      </Col100>
    );
  }
  return <Col100>

      {/* {price && <div className="elementor-element elementor-widget elementor-widget-heading" data-id="a595307" data-element_type="widget" data-widget_type="heading.default">
          <div className="elementor-widget-container">
            <h3 className="elementor-heading-title elementor-size-default">
              Price: ${price.toFixed(2)}
            </h3>
          </div>
        </div>} */}
      
      <form onSubmit={handleSubmit} className="order-form elementor-form" id="orderForm" name="OrderForm">
          <div className="elementor-form-fields-wrapper elementor-labels elementor-column-gap-default">
            <div className="et_pb_button_module_wrapper et_pb_button_0_wrapper et_pb_button_alignment_left et_pb_module ">
              <button type="submit" className="da-button">
                <span>
                  <span className="elementor-button-text">
                    {paymentRequired ? purchaseButtonText : activateButtonText}
                  </span>
                  {" "}
                  <i aria-hidden="true" className="fas fa-angle-right" />
                </span>
              </button>
            </div>
          </div>
        </form>

        {partner && <span onClick={() => setShowDiscountCode(true)}>Code {partner} Applied</span>}

        {(!partner || showDiscountCode) && <div className="et_pb_module et_pb_toggle et_pb_toggle_0 et_pb_toggle_item  et_pb_text_align_left et_pb_toggle_close">
          <h5 className="mt-1" onClick={() => setShowDiscountCode(true)}>Apply Offer Code</h5>
          {showDiscountCode && <div className="clearfix">
            <div id="et_pb_contact_form_0" className="et_pb_module et_pb_contact_form_0 et_pb_contact_form_container clearfix" data-form_unique_num="0" data-form_unique_id="c1ea54cb-b291-4e65-bedb-5b81307b4599">
              <div className="et-pb-contact-message"></div>
                <div className="">
                  <form onSubmit={handleCode} className="et_pb_contact_form clearfix" id="orderForm" name="OrderForm">
                    <p className="et_pb_contact_field et_pb_contact_field_0 et_pb_contact_field_last" data-id="field_4" data-type="input">
                      <label htmlFor="et_pb_contact_field_4_0" className="et_pb_contact_form_label">Add Discount Code:</label>
                      <div className="d-flex">
                        <input type="text" name="code" id="code" className="da-plugin mr-1" value={inputs.code} onChange={handleChange} data-required_mark="required" data-field_type="input" data-original_id="field_4" placeholder="Add Discount Code:" />
                        <button type="submit" name="et_builder_submit_button"
                          className="et_pb_contact_submit et_pb_button small-button br-5" data-icon="R">Apply</button>                        
                      </div>
                    </p>
                  </form>
                </div>
              </div>
            </div>}
        </div>}
    </Col100>;
}
